import { api } from '../configs/axiosConfigs';

export const getPropertyDetails = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}.json`);
};
